import type {
  AppEntry,
  ShopConfig,
} from "../../../../../pina-server/node_modules/@prisma/client";
import { capturePHEvent } from "../../posthog";
import type {
  FootprintResponse,
  IShopSystemStrategy,
  SitePayload,
} from "../IShopSystemStrategy";

export class WordpressShopSystemStrategy implements IShopSystemStrategy {
  loadingDone(): Promise<void> {
    return new Promise((resolve, reject) => {
      // If we are at mozart...
      if (document.querySelector(".fc-checkout")) {
        // @ts-ignore
        jQuery(document.body).on("updated_checkout", function () {
          resolve();
        });
      } else {
        resolve();
      }
      this.handleOrderConfirmationTracking();
    });
  }

  handleOrderConfirmationTracking() {
    //@ts-ignore
    const payload = window.payload as SitePayload;
    if (payload.orderConfirmation) {
      capturePHEvent(
        payload.orderConfirmation === "true"
          ? "purchase_with_offset"
          : "purchase_without_offset",
      );
    }
  }

  registerEventHandlers(): void {
    // Hook that tells us that the cart was re rendered
    // @ts-ignore
    jQuery(document.body).on("updated_checkout", function () {
      window.dispatchEvent(new CustomEvent("CartReRendered", {}));
    });

    // Hook cart mutations for themes not using blocks.
    // @ts-ignore
    jQuery(document.body).on("updated_cart_totals", () => {
      window.dispatchEvent(new CustomEvent("PriceChanged", {}));
    });

    // Hook totals mutations for blocks themes.
    var cartTotalElement = document.querySelector(
      ".wc-block-components-totals-item__value",
    );
    if (cartTotalElement) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (
            mutation.type === "childList" ||
            mutation.type === "characterData"
          ) {
            if (cartTotalElement) {
              var newTotal = cartTotalElement.textContent;
              window.dispatchEvent(new CustomEvent("PriceChanged", {}));
            }
          }
        });
      });
      observer.observe(cartTotalElement, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }
  async getConfig(
    page: string,
  ): Promise<(ShopConfig & { appEntries: AppEntry[] }) | null> {
    // @ts-ignore
    const response = await fetch(window.payload.ajaxUrl, {
      method: "POST",
      body: new URLSearchParams({
        action: "get-config",
        // We need to send this since requests go to admin-ajax.php, which doesn't know the page type.
        page: page,
        // @ts-ignore
        nonce: window.payload.nonce,
      }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (!response.ok) {
      return null;
    }

    const { data } = await response.json();
    return data;
  }
  async getFootprint(): Promise<FootprintResponse | undefined> {
    try {
      // @ts-ignore
      const response = await fetch(window.payload.ajaxUrl, {
        method: "POST",

        body: new URLSearchParams({
          action: "get-offset-price",
          // @ts-ignore
          nonce: window.payload.nonce,
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const { data } = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return;
    }
  }

  async toggleOffset(state: boolean): Promise<boolean> {
    try {
      // @ts-ignore
      const response = await fetch(window.payload.ajaxUrl, {
        method: "POST",
        body: new URLSearchParams({
          action: `${state ? "enable" : "disable"}-offset`,
          // @ts-ignore
          nonce: window.payload.nonce,
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      if (!response.ok) {
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error fetching data:", error);
      return false;
    }
  }

  async refreshCart() {
    // @ts-ignore
    if (window.wp) {
      // @ts-ignore
      window.wp.data.dispatch("wc/store/cart").invalidateResolutionForStore();
    } else {
      // @ts-ignore
      window.jQuery(document.body).trigger("update_checkout");
    }
  }
}
